export enum AppLangs {
  AR = 'ar',
  EN = 'en',
  TR = 'tr',
}
